var map = {
	"./annuity_start_age.svg": 1315,
	"./car_rental.svg": 1316,
	"./currency.svg": 1317,
	"./deductible.svg": 1318,
	"./default.svg": 1319,
	"./extreme_sport.svg": 1320,
	"./geographical_coverage.svg": 1321,
	"./income_term.svg": 1322,
	"./loss_travel_doc.svg": 1323,
	"./maturity.svg": 1324,
	"./mobile.svg": 1325,
	"./multiple_claims.svg": 1326,
	"./optional_sum_assured.svg": 1327,
	"./owner_type.svg": 1328,
	"./payment_term.svg": 1329,
	"./physio.svg": 1330,
	"./plan_type.svg": 1331,
	"./property_age.svg": 1332,
	"./property_gross_area.svg": 1333,
	"./property_type.svg": 1334,
	"./renewal_term.svg": 1335,
	"./room_type.svg": 1336,
	"./sum_assured.svg": 1337,
	"./target_period.svg": 1338,
	"./underwriting.svg": 1339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1437;